<template>
  <div class="rate_list_box padding-md text-white">
    <div v-if="$route.path.lastIndexOf('/') === 0">
      <!-- 搜索框 -->
      <div class="box-card">
        <div class="text item">
          <el-form inline class="padding-top margin-sm-bottom">
            <el-form-item :label="$t('siteList.siteName')">
              <el-input
                v-model="searchForm.name"
                style="width: 250px"
                clearable
                placeholder="请输入站点名称"
              />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="searchForm.dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                class="btn-purple"
                icon="el-icon-search"
                style="color: #000"
                @click="queryData()"
                v-preventReClick
                >{{ $t("siteList.checkButton") }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 站点数据信息展示表格 -->
      <div class="table-box">
        <!-- <div class="table-add">
          <el-button
            class="btn-blue"
            icon="el-icon-folder-add"
            style="
              color: #8eb8f5;
              border: 0px;
              background: transparent;
              font-size: 15px;
            "
            :disabled="role >= 1 ? true : false"
            @click="onAdd(1)"
            v-preventReClick
            >导出</el-button
          >
        </div> -->
        <el-table
          :data="dataList"
          style="width: 100%"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ 'text-align': 'center' }"
          :row-class-name="tableRowClassName"
          :row-style="{ height: '60px' }"
          :show-overflow-tooltip="true"
        >
          <el-table-column label="账单编号" prop="billNo" min-width="100">
          </el-table-column>
          <el-table-column label="账单月份" prop="billMonth" min-width="100">
          </el-table-column>
          <el-table-column label="投资方" prop="companyA" min-width="100">
          </el-table-column>
          <el-table-column label="业主方" prop="companyB" min-width="100">
          </el-table-column>
          <el-table-column label="合作方式" prop="allotWay" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.allotWay === 1">
                {{ "电价折扣" }}
              </span>
              <span v-else-if="scope.row.allotWay === 2">
                {{ "投资分红" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="抄表方式"
            prop="readMeterUserA"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            label="计费电量"
            prop="totalPowerNum"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.totalPowerNum | num }}
            </template>
          </el-table-column>
          <el-table-column
            label="本期节能效益合计"
            prop="curEconomyBenefit"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.curEconomyBenefit | num }}
            </template>
          </el-table-column>
          <el-table-column
            label="本期节能效益合计"
            prop="curEconomyBenefit"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.curEconomyBenefit | num }}
            </template>
          </el-table-column>
          <el-table-column label="应付费用" prop="payMoney" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.payMoney | num }}
            </template>
          </el-table-column>
          <el-table-column label="支付状态" prop="isPay" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.isPay === 0" class="text-red">
                <!-- {{ "未支付" }} -->
                <icon type="icon-bhjweizhifu" color="red" size="35"></icon>
              </span>
              <span v-else-if="scope.row.isPay === 1" class="text-green">
                <!-- {{ "已支付" }} -->
                <icon type="icon-bhjyizhifu" color="green" size="35"></icon>
              </span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('deviceList.operation')" width="100">
            <!-- 操作按钮 -->
            <template v-slot="{ row }">
              <div class="flex items-middle space-around">
                <!-- <div>
                  <el-button class="text-red" type="text" @click="view(row)">
                    <icon type="icon-chakan" color="#234659" size="25"></icon
                  ></el-button>
                </div> -->
                <div>
                  <el-button
                    class="text-blue"
                    type="text"
                    @click="download(row)"
                  >
                    <icon type="icon-xiazai1" color="#234659" size="25"></icon
                  ></el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 翻页 -->
        <div class="block" style="margin-top: 15px">
          <pagination
            :total="countNum"
            v-on:getCurrent="changeCurrent"
            v-on:getPageSize="changePage"
          ></pagination>
        </div>
      </div>
    </div>
    <rate-update ref="rateUpdate" @refresh="getData"></rate-update>
  </div>
</template>

<script>
import pagination from "../../components/pagination.vue";
import { billQuery, downloadPdf } from "../../api/benefit";
import i18n from "@/lang";
import RateUpdate from "../../components/rateUpdate.vue";
import Icon from "../../components/Icon.vue";
export default {
  components: { pagination, RateUpdate, Icon },
  data() {
    return {
      searchForm: {
        name: "",
        dateValue: "",
      },
      dataList: [],
      searchRules: {
        siteId: [
          { required: false, message: "请输入站点ID", trigger: "blur" },
          {
            pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/,
            message: "用户ID以字母开头，且只能包含英文字母、数字、下划线",
          },
        ],
      },
      object: {
        pageNumber: 1,
        pageSize: 10,
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页的数据条数
      role: 0, //角色
      countNum: 0,
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getData();
    },
    download(row) {
      console.log(row.billNo, "billNo");
      let obj = {
        billNo: row.billNo,
      };
      downloadPdf(obj).then((res) => {
        console.log(res.data.data.url, "downloadPdf");
        window.open("", "_blank").location.href = res.data.data.url;
      });
    },
    getData() {
      this.queryData();
    },
    onAdd(type, row = {}) {
      this.$refs.rateUpdate.open(type, row);
    },
    queryData() {
      let date = null;
      if (this.searchForm.dateValue != "") {
        date = this.searchForm.dateValue;
      }
      let obj = {
        pageNumber: this.object.pageNumber,
        pageSize: this.object.pageSize,
        para: {
          name: this.searchForm.name,
          dateRange: date,
        },
      };
      billQuery(obj).then((res) => {
        if (res.data.data.list.length == 0) {
          this.$message({
            type: "warning",
            message: "暂无结果",
          });
        } else {
          this.countNum = res.data.data.countNum;
          this.dataList = res.data.data.list;
        }
      });
    },
    toDevice(id) {
      this.$router.push({
        name: "DeviceList",
        query: {
          id: id,
        },
      });
    },
    changeCurrent(data) {
      this.object.pageNumber = data;
      this.currentPage = data;
      this.getData();
    },
    changePage(data) {
      this.object.pageSize = data;
      this.pageSize = data;
      console.log(this.object);
      this.getData();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "";
      } else {
        return "warning-row";
      }
    },
  },
  flexWidth(prop, tableData, title, num = 0) {
    if (tableData.length === 0) {
      //表格没数据不做处理
      return;
    }
    let flexWidth = 0; //初始化表格列宽
    let columnContent = ""; //占位最宽的内容
    let canvas = document.createElement("canvas");
    let context = canvas.getContext("2d");
    context.font = "14px Microsoft YaHei";
    if (prop === "" && title) {
      //标题长内容少的，取标题的值,
      columnContent = title;
    } else {
      // 获取该列中占位最宽的内容
      let index = 0;
      for (let i = 0; i < tableData.length; i++) {
        const now_temp = tableData[i][prop] + "";
        const max_temp = tableData[index][prop] + "";
        const now_temp_w = context.measureText(now_temp).width;
        const max_temp_w = context.measureText(max_temp).width;
        if (now_temp_w > max_temp_w) {
          index = i;
        }
      }
      columnContent = tableData[index][prop];
      //比较占位最宽的值跟标题、标题为空的留出四个位置
      const column_w = context.measureText(columnContent).width;
      const title_w = context.measureText(title).width;
      if (column_w < title_w) {
        columnContent = title || "留四个字";
      }
    }
    // 计算最宽内容的列宽
    let width = context.measureText(columnContent);
    flexWidth = width.width + 40 + num;
    return flexWidth + "px";
  },
  filters: {
    num: (val, fix = 2) => {
      if (val < 0) {
        val = parseFloat(val);
        val = val.toFixed(fix); // 保留小数2位
        val = Math.abs(val);
        val = "" + val; // 转换成字符串
        var int = val.slice(0, fix * -1 - 1); // 拿到整数
        var ext = val.slice(fix * -1 - 1); // 获取到小数
        int = int.split("").reverse().join(""); // 翻转整数
        var temp = ""; // 临时变量
        for (var i = 0; i < int.length; i++) {
          temp += int[i];
          if ((i + 1) % 3 == 0 && i != int.length - 1) {
            temp += ","; // 每隔三个数字拼接一个逗号
          }
        }
        temp = temp.split("").reverse().join(""); // 加完逗号之后翻转
        temp = temp + ext; // 整数小数拼接
        return "-" + temp; // 返回
      } else if (val != "-" && val != "" && val != null && val > 0) {
        val = parseFloat(val);
        val = val.toFixed(fix); // 保留小数2位
        val = "" + val; // 转换成字符串
        int = val.slice(0, fix * -1 - 1); // 拿到整数
        ext = val.slice(fix * -1 - 1); // 获取到小数
        int = int.split("").reverse().join(""); // 翻转整数
        temp = ""; // 临时变量
        for (i = 0; i < int.length; i++) {
          temp += int[i];
          if ((i + 1) % 3 == 0 && i != int.length - 1) {
            temp += ","; // 每隔三个数字拼接一个逗号
          }
        }
        temp = temp.split("").reverse().join(""); // 加完逗号之后翻转
        temp = temp + ext; // 整数小数拼接
        return temp; // 返回
      } else if (val == 0 || val == "0") {
        return val;
      } else {
        return "-";
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.rate_list_box{
    width: 100%;
    box-sizing: border-box;
    height: calc(100vh - 130px);
    overflow: auto;
}
.table-box{
  padding: 20px;
    // background: linear-gradient(45deg, #35478a, #162257);
    background: #102135
    border-radius: 10px;
}
.table-add{
  margin-bottom: 20px
}
/deep/.el-table, .el-table tr, .el-table td, .el-table th {
    background-color: transparent!important;
}
</style>
